module.exports = __webpack_public_path__ + "media/images/dividend/ic_cc-dfdec4aa99bef81d825646e0c9f4e845.svg";